"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCourseReview = exports.updateCourseReviews = exports.deleteCourseReview = exports.approveCourseReview = exports.addCourseReview = exports.getCourseReview = exports.getCourseReviews = void 0;
const getCourseReviews = async (supabase) => {
    const { data, error } = await supabase
        .from("course_reviews")
        .select(`*, courses(id, name, slug)`)
        .order("created_at", { ascending: false });
    if (!error)
        return data;
    return error;
};
exports.getCourseReviews = getCourseReviews;
const getCourseReview = async (supabase, id) => {
    const { data, error } = await supabase
        .from("course_reviews")
        .select(`*`)
        .eq("id", id)
        .single();
    if (!error)
        return data;
    return error;
};
exports.getCourseReview = getCourseReview;
const addCourseReview = async (supabase, obj) => {
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        obj.modified_by = user?.id;
        obj.created_by = user?.id;
    }
    const { data, error } = await supabase
        .from("course_reviews")
        .insert([obj])
        .select()
        .single();
    if (!error)
        return data;
    return error;
};
exports.addCourseReview = addCourseReview;
const approveCourseReview = async (supabase, id, status) => {
    const { data, error } = await supabase
        .from("course_reviews")
        .update({ approved: status })
        .eq("id", id);
    if (!error)
        return data;
    return error;
};
exports.approveCourseReview = approveCourseReview;
const deleteCourseReview = async (supabase, id) => {
    const { data, error } = await supabase
        .from("course_reviews")
        .delete()
        .eq("id", id);
    if (!error)
        return data;
    return error;
};
exports.deleteCourseReview = deleteCourseReview;
const updateCourseReviews = async (supabase, obj) => {
    const { data, error } = await supabase.from("course_reviews").upsert(obj);
    if (!error)
        return data;
    return error;
};
exports.updateCourseReviews = updateCourseReviews;
const updateCourseReview = async (supabase, obj) => {
    delete obj.courses;
    delete obj.created_by_user;
    delete obj.modified_by_user;
    const { data, error } = await supabase
        .from("course_reviews")
        .update(obj)
        .eq("id", obj.id);
    if (!error)
        return data;
    return error;
};
exports.updateCourseReview = updateCourseReview;
